module.exports = __webpack_public_path__ + "static/media/11_shape_l.37780edc.webp";